import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ReporteListaPreciosService } from '../../services/reportes/reporte-lista-precios/reporte-lista-precios.service';
import { DataDepartamento, DataGrupo, DataMarcas, DataSucursales, Grupos, sucursal } from '../ABC/utils/models/ABC';
import { ABCService } from '../ABC/utils/services/ABC.service';
import { FiltrosComponent } from '../../core/components/filtros/filtros.component';
import { MatDialog } from '@angular/material/dialog';
import { PeriodoInventarioService } from '../../services/inventario/periodo/periodo-inventario.service';
import { ClientesService } from '../../services/clientes.service';

export interface Cliente {
  ClienteID: string;
  Nombre: string;
}

@Component({
  selector: 'app-reporte-lista-precios',
  templateUrl: './reporte-lista-precios.component.html',
  styleUrls: ['./reporte-lista-precios.component.scss']
})

export class ReporteListaPreciosComponent implements OnInit {
  public listaClientes: Cliente[] = [];
  filteredOptions: Observable<Cliente[]>;
  public valueInput: string;
  public cliente: string;

  tipoReporte = new FormControl('C', [Validators.required]);
  clienteId = new FormControl('', [Validators.required]);
  filtros: FormGroup;

  sucursales: any[] = [];
  sucursalesSeleccionadas: any[] = [];
  almacenes: any[] = [];
  almacenesSeleccionados: any[] = [];
  almacenesTmp: any[] = [];
  departamentos: any[] = [];
  departamentosSeleccionados: any[] = [];
  grupos: any[] = [];
  gruposFiltrados: any[] = [];
  gruposSeleccionados: any[] = [];
  marcas: any[] = [];
  marcasSeleccionados: any[] = [];

  tiposPrecio: any[] = [];

  datosPeticion: any = {

  }

  constructor(
    private reporteListaPreciosService: ReporteListaPreciosService,
    private abcService: ABCService,
    private periodoInventarioService: PeriodoInventarioService,
    private clientesService: ClientesService,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private matDialog: MatDialog
  ) { }


  ngOnInit() {
    this.getClientes();
    this.filteredOptions = this.clienteId.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );

    this.inicializarVariables();
  }

  inicializarVariables() {
    this.filtros = this.formBuilder.group({
      sucursal: new FormControl('', [Validators.required]),
      almacen: new FormControl({ value: '', disabled: true }, [Validators.required]),
      departamento: new FormControl('', [Validators.required]),
      grupo: new FormControl('', [Validators.required]),
      marca: new FormControl('', [Validators.required]),
      tipoPrecio: new FormControl('', [Validators.required])
    })

    this.getSucursales();
    this.getAlmacenes(0);
    this.getDeparamentos(0);
    this.getGrupos(0);
    this.getMarcas();
    this.getTiposPrecio();
  }

  private getClientes() {
    this.reporteListaPreciosService.getClientes().subscribe(data => {
      if (data) {
        if (data.error == false) {
          this.listaClientes = data.clientes;
        }
      }
    })
  }

  private getDeparamentos(clienteId: number) {
    this.getInputValue('departamento').disable();
    this.abcService.getDepartamentosAbcDos(clienteId).subscribe((res: DataDepartamento) => {
      this.departamentos = res.departamentos;
      this.getInputValue('departamento').enable();
    });
  }

  private getGrupos(clienteId: number) {
    this.getInputValue('grupo').disable();
    this.abcService.getGruposAbcDos(clienteId).subscribe((res: DataGrupo) => {
      this.grupos = res.grupos;
      this.getInputValue('grupo').enable();
    });
  }

  private getMarcas() {
    this.getInputValue('marca').disable();
    this.abcService.getMarcasAbc().subscribe((res: DataMarcas) => {
      this.marcas = res.marcas;
      this.getInputValue('marca').enable();
    });
  }

  private getSucursales() {
    this.abcService.getSucursales().subscribe((res: DataSucursales) => {
      this.sucursales = res.sucursales;
    });
  }

  private getAlmacenes = (sucursal: number) => {

    this.filtros.get('almacen').setValue('');
    this.periodoInventarioService
      .almacen(sucursal)
      .then((res) => {
        this.almacenesTmp = res.response;
        //console.log(this.almacenes);

      })
      .catch((error) => {
        Swal.fire({
          type: 'error',
          title: 'Error',
          text: error.message,
          footer: 'Comunícate para resolver el problema',
        });
      });
  };

  getTiposPrecio() {
    this.clientesService
      .getVendedores()
      .then(res => {
        if (res.message === 'true') {
          this.tiposPrecio = res.tipoPrecio;
        }
      })
      .catch(err => {
        // console.log(err);
      });
  }

  public getInputValue(control: string) {
    return this.filtros.get(control);
  }

  public getListaPrecios() {
    const tipoReporte = this.tipoReporte.value;

    let datos: any = {
      tipoReporte: tipoReporte,
      cliente: tipoReporte == 'C' ? this.cliente : '0',
    }

    if (tipoReporte == 'TP') {
      datos = {
        ...datos,
        ...this.datosPeticion
      }
    }

    this.spinner.show('spinner-reporte-lista-clientes');
    if (this.clienteId.value.length > 0 || tipoReporte == 'TP') {
      this.reporteListaPreciosService.setExportExcel(this.cliente, datos).then((res) => {
        this.spinner.hide('spinner-reporte-lista-clientes');
      }).catch((err: any) => {
        this.spinner.hide('spinner-reporte-lista-clientes');
        Swal.fire({
          type: 'warning',
          title: 'Advertencia',
          text: err.message,
        });
      });
    }
  }

  public selectLista(cliente: Cliente) {
    this.valueInput = cliente.ClienteID + ' - ' + cliente.Nombre;
    this.cliente = cliente.ClienteID;
  }

  seleccionarTipoPrecio(event: any) {
    this.datosPeticion.allTipoPrecio = event.value.length == this.tiposPrecio.length;
    this.datosPeticion.tipoPrecio = this.datosPeticion.allTipoPrecio ? [] : event.value;
  }

  public modalClientes(opcion: number) {
    let list = [];
    let listCheck = [];
    switch (opcion) {
      case 1:
        list = this.departamentos;
        listCheck = this.departamentosSeleccionados;
        break;
      case 2:
        list = this.gruposFiltrados.length > 0 ? this.gruposFiltrados : this.grupos;
        listCheck = this.gruposSeleccionados;
        break;
      case 5:
        list = this.marcas;
        listCheck = this.marcasSeleccionados;
        break;
      case 6:
        list = this.sucursales;
        listCheck = this.sucursalesSeleccionadas;
        break;

      case 7:
        list = this.almacenes;
        listCheck = this.almacenesSeleccionados;
        break;
    }
    const dialogRef = this.matDialog.open(FiltrosComponent, {
      disableClose: true,
      width: '28%',
      data: {
        opcion,
        lista: list,
        listaCheck: listCheck,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      switch (opcion) {
        case 1: // Departamentos
          this.departamentosSeleccionados = result;

          this.datosPeticion.allDepartamentos =
            this.departamentosSeleccionados.length == this.departamentos.length;

          this.datosPeticion.departamentos = this.datosPeticion.allDepartamentos
            ? []
            : this.departamentosSeleccionados;

          if (this.departamentosSeleccionados.length > 0) {
            this.getInputValue('grupo').setValue('');
            //this.getInputValue('grupo').enable();
          } else {
            this.getInputValue('grupo').setValue('');
            //this.getInputValue('grupo').disable();
          }
          const departamento = this.departamentosSeleccionados.length > 0 ? this.departamentosSeleccionados[0].Nombre.slice(0, 20) : '';
          const departamento2 = this.departamentosSeleccionados.length > 1 ?
            ' (+' + (this.departamentosSeleccionados.length - 1) + ' ' + (this.departamentosSeleccionados.length === 2 ? 'Departamento' : 'Departamentos') + ')' : '';

          if (this.departamentosSeleccionados.length > 0) {
            this.getInputValue('departamento').setValue(departamento + ' ' + departamento2);
          } else {
            this.getInputValue('departamento').setValue('');
          }
          this.gruposFiltrados = this.filterGrupos();
          this.gruposSeleccionados = [];
          break;
        case 2: // Grupos
          this.gruposSeleccionados = result;

          this.datosPeticion.allGrupos =
            this.gruposSeleccionados.length == this.grupos.length;

          this.datosPeticion.grupos = this.datosPeticion.allGrupos
            ? []
            : this.gruposSeleccionados;

          const grupo = this.gruposSeleccionados.length > 0 ? this.gruposSeleccionados[0].Nombre.slice(0, 20) : '';
          const grupo2 = this.gruposSeleccionados.length > 1 ?
            ' (+' + (this.gruposSeleccionados.length - 1) + ' ' + (this.gruposSeleccionados.length === 2 ? 'Grupo' : 'Grupos') + ')' : '';
          if (this.gruposSeleccionados.length > 0) {
            this.getInputValue('grupo').setValue(grupo + ' ' + grupo2);
          } else {
            this.getInputValue('grupo').setValue('');
          }
          break;
        case 5: // marcas
          this.marcasSeleccionados = result;

          this.datosPeticion.allMarcas =
            this.marcasSeleccionados.length == this.marcas.length;

          this.datosPeticion.marcas = this.datosPeticion.allMarcas
            ? []
            : this.marcasSeleccionados;

          const marca = this.marcasSeleccionados.length > 0 ? this.marcasSeleccionados[0].Nombre.slice(0, 20) : '';
          const marca2 = this.marcasSeleccionados.length > 1 ?
            ' (+' + (this.marcasSeleccionados.length - 1) + ' ' + (this.marcasSeleccionados.length === 2 ?
              'Marca' : 'Marcas') + ')' : '';
          if (this.marcasSeleccionados.length > 0) {
            this.getInputValue('marca').setValue(marca + ' ' + marca2);
          } else {
            this.getInputValue('marca').setValue('');
          }
          break;
        case 6: // sucursales
          this.sucursalesSeleccionadas = result;

          this.datosPeticion.allSucursales =
            this.sucursalesSeleccionadas.length == this.sucursales.length;

          this.datosPeticion.sucursales = this.datosPeticion.allSucursales
            ? []
            : this.sucursalesSeleccionadas;

          if (this.sucursalesSeleccionadas.length > 0) {
            this.getInputValue('almacen').setValue('');
            this.getInputValue('almacen').enable();
          } else {
            this.getInputValue('almacen').setValue('');
            this.getInputValue('almacen').disable();
          }
          const sucursales =
            this.sucursalesSeleccionadas.length > 0
              ? this.sucursalesSeleccionadas[0].Nombre.slice(0, 20)
              : '';
          const sucursales2 =
            this.sucursalesSeleccionadas.length > 1
              ? ' (+' +
              (this.sucursalesSeleccionadas.length - 1) +
              ' ' +
              (this.sucursalesSeleccionadas.length === 2
                ? 'Sucursal'
                : 'Sucursales') +
              ')'
              : '';
          if (this.sucursalesSeleccionadas.length > 0) {
            this.getInputValue('sucursal').setValue(
              sucursales + ' ' + sucursales2
            );

            this.almacenes = [];
            this.almacenesSeleccionados = [];
            this.sucursalesSeleccionadas.forEach((sucursal: sucursal) => {
              this.almacenesTmp.forEach((almacen: any) => {
                if (almacen.Sucursal == sucursal.SucursalId) {
                  this.almacenes.push({
                    id: almacen.AlmacenID,
                    Nombre: almacen.NombreAlmacen,
                  });
                }
              });
            });
          } else {
            this.getInputValue('sucursal').setValue('');
            this.almacenes = [];
          }

          break;
        case 7: // Almacenes
          this.almacenesSeleccionados = result;

          this.datosPeticion.allAlmacenes =
            this.almacenesSeleccionados.length == this.almacenes.length;

          this.datosPeticion.almacenes = this.datosPeticion.allAlmacenes
            ? []
            : this.almacenesSeleccionados;

          const almacen =
            this.almacenesSeleccionados.length > 0
              ? this.almacenesSeleccionados[0].Nombre.slice(0, 20)
              : '';
          const almacen2 =
            this.almacenesSeleccionados.length > 1
              ? ' (+' +
              (this.almacenesSeleccionados.length - 1) +
              ' ' +
              (this.almacenesSeleccionados.length === 2
                ? 'Almacén'
                : 'Almacenes') +
              ')'
              : '';
          if (this.almacenesSeleccionados.length > 0) {
            this.getInputValue('almacen').setValue(almacen + ' ' + almacen2);
          } else {
            this.getInputValue('almacen').setValue('');
          }
          break;
      }
    });
  }

  public filterGrupos(): Grupos[] {
    return this.grupos.filter((option) => {
      let coincidencia = false;
      this.departamentosSeleccionados.forEach(value => {
        if (option.DepartamentoID == value.DepartamentoID) {
          coincidencia = true;
        }
      });
      return coincidencia;
    });
  }

  private _filter(value: string): Cliente[] {
    const filterValue = value.toLowerCase();
    return this.listaClientes.filter(option => option.ClienteID.toLowerCase().includes(filterValue) ||
      option.Nombre.toLowerCase().includes(filterValue));
  }
}
